import type { Infer } from 'superstruct';
import { object, size, string } from 'superstruct';
import { notEmpty } from '../../../../form';

export const MfaSmsNumberFormValidation = object({
  phoneNumber: notEmpty(size(string(), 6, 20)),
});

export type MfaSmsNumberFields = Infer<typeof MfaSmsNumberFormValidation>;
